import { createSlice } from '@reduxjs/toolkit';

import { CategoriesInitialStateProps } from '../types/categoriesTypes';
const name = 'categoryTemplates';

const INITIAL_STATE: CategoriesInitialStateProps = {
  categories: [],
  currentCategory: null,
  isCategoriesLoading: false,
  isCategoryLoading: false,
  error: null,

  isCreateRequestLoading: false,
  isUpdateRequestLoading: false,
  isRemoveRequestLoading: false,
};

const categoryTemplatesSlice = createSlice({
  name,
  initialState: INITIAL_STATE,
  reducers: {
    getCategoryTemplates: state => {
      state.isCategoriesLoading = true;
    },
    getCategoryTemplatesSuccess: (state, action) => {
      state.isCategoriesLoading = false;
      state.categories = action.payload;
    },
    getCategoryTemplatesFailure: (state, action) => {
      state.isCategoriesLoading = false;
      state.error = action.payload;
    },

    createCategoryTemplate: (state, action) => {
      state.isCreateRequestLoading = true;
    },
    createCategoryTemplateSuccess: state => {
      state.isCreateRequestLoading = false;
    },
    createCategoryTemplateFailure: (state, action) => {
      state.isCreateRequestLoading = false;
      state.error = action.payload;
    },

    updateCategoryTemplate: (state, action) => {
      state.isUpdateRequestLoading = true;
    },
    updateCategoryTemplateSuccess: state => {
      state.isUpdateRequestLoading = false;
    },
    updateCategoryTemplateFailure: (state, action) => {
      state.isUpdateRequestLoading = false;
      state.error = action.payload;
    },

    removeCategoryTemplate: (state, action) => {
      state.isRemoveRequestLoading = true;
    },
    removeCategoryTemplateFailure: (state, action) => {
      state.isRemoveRequestLoading = false;
      state.error = action.payload;
    },
    removeCategoryTemplateSuccess: state => {
      state.isRemoveRequestLoading = false;
    },
  },
});

export const {
  getCategoryTemplates,
  getCategoryTemplatesFailure,
  getCategoryTemplatesSuccess,

  createCategoryTemplate,
  createCategoryTemplateSuccess,
  createCategoryTemplateFailure,

  updateCategoryTemplate,
  updateCategoryTemplateSuccess,
  updateCategoryTemplateFailure,

  removeCategoryTemplate,
  removeCategoryTemplateFailure,
  removeCategoryTemplateSuccess,
} = categoryTemplatesSlice.actions;

export default categoryTemplatesSlice.reducer;
